/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpServiceId, PERMISSIONS } from '@squiz/dxp-auth';
import { hasPermission } from '../HasPermission/HasPermission';

/**
 * Check for a permission in a particular service.
 * @param permission Permission to check (without service prefix).
 * @param serviceId The ID of the service (eg: dxpLogging).
 */
export const hasPermissionForService = (permission: string, serviceId: DxpServiceId): boolean => {
  if (PERMISSIONS[serviceId] && Object.prototype.hasOwnProperty.call(PERMISSIONS[serviceId], permission)) {
    return hasPermission(`${serviceId}.${permission}`);
  }

  return false;
};
